module.exports = __webpack_public_path__ + "assets/img/img323.2a7e0b2d.png";